import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Actions\Admin\UpdateWelcomeMessage::__invoke
* @see app/Actions/Admin/UpdateWelcomeMessage.php:17
* @route '/admin/settings/welcome-message'
*/
export const update = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/admin/settings/welcome-message',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Actions\Admin\UpdateWelcomeMessage::__invoke
* @see app/Actions/Admin/UpdateWelcomeMessage.php:17
* @route '/admin/settings/welcome-message'
*/
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Admin\UpdateWelcomeMessage::__invoke
* @see app/Actions/Admin/UpdateWelcomeMessage.php:17
* @route '/admin/settings/welcome-message'
*/
update.patch = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(options),
    method: 'patch',
})

const welcomeMessage = {
    update: Object.assign(update, update),
}

export default welcomeMessage